// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--A7LZk","shopDetailTitle":"shopDetailTitle--RuboK","markerAnimationScale":"markerAnimationScale--pAPVm"};